// extracted by mini-css-extract-plugin
export default {"wishlistWidget":"WishlistWidgetWrapper-module__wishlistWidget___mZv1z"};